import { Component, OnInit, AfterViewInit, OnDestroy, ViewChildren, ElementRef, ViewChild } from "@angular/core";
import { AuthService } from "../auth.service";
import { AppCommonService } from "../appcommon.service";
import { Subject } from "rxjs/Subject";
import { Observable } from "rxjs/Observable";
import { DataTableDirective } from "angular-datatables";
import { ICards, IDrawingAccounts, IDrawings, CardTranLiveCardModel, CardTranDrawingPointModel, CardTranDrawingModel, DrawingsDataTablesResponse, AcceptedResponse } from "./cardtransaction"
import { CardTransactionService } from "./cardtransaction.service";
//import * as $ from 'jquery';
import { IAccount } from "../headerandnavigation/accounts/account";
import { HeaderAndNavigationService } from "../headerandnavigation/headerandnavigation.service";
import { ApiEndPoints } from "../api.endpoints";
import { LoaderService } from "../LoaderService";
import { ILoggedUser } from "../headerandnavigation/loggeduser/loggeduser";
import { HttpClient, HttpResponse } from '@angular/common/http';
import { NgForm } from "@angular/forms";
import { ResponseContentType, Http } from "@angular/http";
declare var $: any;

@Component({
    templateUrl: "./accountcardtransaction.component.html"
})
export class AccountCardTransactionComponent implements OnInit, AfterViewInit, OnDestroy {
    public pageTitle: string = 'Transactions Download';
    @ViewChild('accountcardTransaction') cardTransactionFrm: NgForm;
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;
    cardList: ICards[];
    drawingAccountList: IDrawingAccounts[];
    drawingList: IDrawings[];
    drawingListDummy: IDrawings[];
    cardNumbers = [];
    dtOptions: any = {};
    dtOptionsCardsTable: any = {};
    dtTrigger: Subject<any> = new Subject();
    cardTransaction: any = {};
    value: Date;
    value1: Date;
    public accessAccounts: IAccount[];
    loggedUser: ILoggedUser;
    referenceNumber: string = "";
    cardTransactionTypeValue: any = undefined;
    showDrawings: boolean = false;
    selectedDrawingPoint: any = {};
    cardListData: ICards[];
    constructor(private http: HttpClient, private httpcall: Http, private authService: AuthService, private appCommonService: AppCommonService,
        public cardTransactionService: CardTransactionService,
        public headerAndNavigationService: HeaderAndNavigationService,
        public loaderService: LoaderService
    ) {
        this.appCommonService.pageContentAdditionalClass = "";
        this.appCommonService.pageName = this.pageTitle;

    }

    ngOnInit(): void {
        this.cardTransaction.drawingAccount = "All";
        this.headerAndNavigationService.showhideNav(false, true);
        this.accessAccounts = this.authService.getSelectedAccessAccounts();
        this.loadCards();
        //this.loadDrawingPointList();
        this.datefilerInitiate();
        this.dtOption();
        this.dtOptionCardsTable();

        $(document).ready(function () {

            //$('#selectcardsdatatable').DataTable({
            //    //dom: "fltB<'row DTTTFooter'<'col-sm-6'i><'col-sm-6'p>>",
            //    dom: '<"top"i<"clear">>rt<"bottom"i<"clear">>',

            //    info: false,
            //    order: [],
            //    columnDefs: [{ orderable: false, targets: [0, 3] }]
            //});

            //Check All Functionality
            $('#selectcardsdatatable thead th input[type=checkbox]').change(function () {
                var set = $("#selectcardsdatatable tbody tr input[type=checkbox]");
                var checked = $(this).is(":checked");
                $(set).each(function () {
                    if (checked) {
                        $(this).prop("checked", true);
                        $(this).parents('tr').addClass("active");
                    } else {
                        $(this).prop("checked", false);
                        $(this).parents('tr').removeClass("active");
                    }
                });

            });
            $('#selectcardsdatatable tbody tr input[type=checkbox]').change(function () {
                $(this).parents('tr').toggleClass("active");
            });

            /*--Common Tabs datatable--*/

        });

        this.loggedUser = this.headerAndNavigationService.getLoggedUser();
        if (this.loggedUser == null) {
            this.headerAndNavigationService.RedirectToLogin();
        }
        //this.headerAndNavigationService.getLoggedUser()
        //  .subscribe(
        //  (user: ILoggedUser) => {
        //    this.loggedUser = user;
        //  },
        //  (error: any) => {
        //    this.headerAndNavigationService.showError("Logged user retrieval problem", <any>error);
        //    this.headerAndNavigationService.RedirectToLogin();
        //  }
        //);
    }

    ngAfterViewInit(): void {
        //this.appCommonService.loadRequiredJS();

        $('table.dataTable tbody > tr > td:first-child').on('click', function (e) {
            //alert();
            $(this).parent().removeClass('shown');
        });

        $('.showdorpdown').on('click', function (e) {
            $('.showtable').toggleClass('open');
        });

        $.extend($.fn.dataTableExt.oSort, {
            "non-empty-string-asc": function (str1, str2) {
                if (str1 == null || str1 == "")
                    return 1;
                if (str2 == null || str2 == "")
                    return -1;
                return ((str1 < str2) ? -1 : ((str1 > str2) ? 1 : 0));
            },

            "non-empty-string-desc": function (str1, str2) {
                if (str1 == null || str1 == "")
                    return 1;
                if (str2 == null || str2 == "")
                    return -1;
                return ((str1 < str2) ? 1 : ((str1 > str2) ? -1 : 0));
            }
        });

        setTimeout(() => {
            $('.defalutType').trigger('click');
        }, 100);
    }
    datefilerInitiate() {
        $(document).ready(function () {
            jQuery.extend($.fn.dataTableExt.oSort, {
                "date-uk-pre": function (a) {
                    if (a == null || a == "") {
                        return 0;
                    }
                    var ukDatea = a.split('/');
                    return (ukDatea[2] + ukDatea[1] + ukDatea[0]) * 1;
                },

                "date-uk-asc": function (a, b) {
                    return ((a < b) ? -1 : ((a > b) ? 1 : 0));
                },

                "date-uk-desc": function (a, b) {
                    return ((a < b) ? 1 : ((a > b) ? -1 : 0));
                }
            });
        });
    }

    dtOption() {
        var athis = this;

        this.dtOptions = {
            dom: '<"top"fipB<"clear">>rt<"bottom"ipB<"clear">>',
            responsive: true,
            info: false,
            iDisplayLength: 15,
            order: [],
            columnDefs: [
                { type: 'date-uk', targets: [0, 19] },
                { "type": "non-empty-string", targets: [4, 5, 6, 8, 9, 10] }
            ],
            buttons: [
                {
                    extend: 'collection',
                    text: 'Download <i class="fa fa-angle-down"></i>',
                    buttons: [
                        {
                            text: '<i class="fa fa-file-excel-o"> Excel</i>',
                            titleAttr: 'Excel',
                            action: function (e, dt, node, config) {
                                athis.downloadCardTransaction('Excel');
                            }
                        },
                        {
                            text: '<i class="fa fa-file-csv-o"> CSV</i>',
                            titleAttr: 'CSV',
                            action: function (e, dt, node, config) {
                                athis.downloadCardTransaction('Csv');
                            }
                        },
                        {
                            text: '<i class="fa fa-file-pdf-o"> PDF</i>',
                            titleAttr: 'PDF',
                            action: function (e, dt, node, config) {
                                athis.downloadCardTransaction('Pdf');
                            }
                        }
                    ]
                }
            ],
            //pagingType: 'full_numbers',        
            pageLength: 15,
            serverSide: true,
            processing: true,
            deferRender: true,
            ajax: (dataTablesParameters: any, callback) => {
                this.loaderService.display(true);
                this.http
                    .post<DrawingsDataTablesResponse>(
                        (ApiEndPoints.BaseURL + ApiEndPoints.GetCardTranDrawingsData + "?referenceNumber=" + this.referenceNumber),
                        dataTablesParameters, {}
                    ).subscribe(resp => {
                        if (resp.error == null) {
                            if (resp.data.length > 0) {
                                this.drawingList = resp.data;
                                this.loaderService.display(false);
                            }
                            else {
                                this.drawingList = null;
                                this.loaderService.display(false);
                            }
                        }
                        else {
                            this.loaderService.display(false);
                            if (resp.error == "NoReferenceFound") {
                                this.cardTransactionFrm.ngSubmit.emit();
                            }
                        }
                        callback({
                            recordsTotal: resp.recordsTotal,
                            recordsFiltered: resp.recordsFiltered,
                            data: []
                        });
                    });
            },
            initComplete: function () {
                var api = this.api();
                api.columns().every(function () {
                    var that = this;
                    //console.log(that);
                    $('input', this.footer()).on('keyup change', function () {
                        if (that.search() !== this.value) {
                            that.search(this.value).draw();
                        }
                    });
                });
            }

        }
        this.loadCards();
    }
    dtOption_result() {
        var athis = this;

        this.dtOptions = {
            dom: '<"top"fipB<"clear">>rt<"bottom"ipB<"clear">>',
            responsive: true,
            info: false,
            iDisplayLength: 15,
            order: [],
            columnDefs: [
                { type: 'date-uk', targets: [0, 19] },
                { "type": "non-empty-string", targets: [4, 5, 6, 8, 9, 10] }
            ],
            buttons: [
                {
                    extend: 'collection',
                    text: 'Download <i class="fa fa-angle-down"></i>',
                    buttons: [
                        {
                            text: '<i class="fa fa-file-excel-o"> Excel</i>',
                            titleAttr: 'Excel',
                            action: function (e, dt, node, config) {
                                athis.downloadCardTransaction('Excel');
                            }
                        },
                        {
                            text: '<i class="fa fa-file-csv-o"> CSV</i>',
                            titleAttr: 'CSV',
                            action: function (e, dt, node, config) {
                                athis.downloadCardTransaction('Csv');
                            }
                        },
                        {
                            text: '<i class="fa fa-file-pdf-o"> PDF</i>',
                            titleAttr: 'PDF',
                            action: function (e, dt, node, config) {
                                athis.downloadCardTransaction('Pdf');
                            }
                        }
                    ]
                }
            ],
            //pagingType: 'full_numbers',        
            pageLength: 15,
            serverSide: true,
            processing: true,
            deferRender: true,
            ajax: (dataTablesParameters: any, callback) => {
                this.loaderService.display(true);
                this.http
                    .post<DrawingsDataTablesResponse>(
                        (ApiEndPoints.BaseURL + ApiEndPoints.GetCardTranDrawingsData + "?referenceNumber=" + this.referenceNumber),
                        dataTablesParameters, {}
                    ).subscribe(resp => {
                        if (resp.error == null) {
                            if (resp.data.length > 0) {
                                this.drawingList = resp.data;
                                this.loaderService.display(false);
                            }
                            else {
                                this.drawingList = null;
                                this.loaderService.display(false);
                            }
                        }
                        else {
                            this.loaderService.display(false);
                            if (resp.error == "NoReferenceFound") {
                                this.cardTransactionFrm.ngSubmit.emit();
                            }
                        }
                        callback({
                            recordsTotal: resp.recordsTotal,
                            recordsFiltered: resp.recordsFiltered,
                            data: resp.data
                            //data:[]
                        });
                    });
            },
            columns: [{
                data: 'drawnDate',
                render: function (data, type, item, meta) {

                    var d = new Date(data);
                    var returndat = ((d.getDate() > 9) ? d.getDate() : ('0' + d.getDate())) + '/' + ((d.getMonth() > 8) ? (d.getMonth() + 1) : ('0' + (d.getMonth() + 1))) + '/' + d.getFullYear();
                    return returndat + " " + ((item.drawnTime != "undefined" && item.drawnTime != "") ? item.drawnTime : "");
                }
            },
            { data: 'accountNumber' },
            { data: 'subAccountNumber' },
            { data: 'shortCardNumber' },
            { data: 'driverName' },
            { data: 'registration' },
            { data: 'vrnSite' },
            { data: 'odometer' },
            { data: 'siteName' },
            { data: 'sitePostCode' },
            { data: 'product' },
            { data: 'invoiceNumber' },
            {
                data: 'quantity',
                render: function (data, type, item, meta) {
                    var d = parseFloat(data).toFixed(2);
                    return d;
                }
            },
            {
                data: 'price',
                render: function (data, type, item, meta) {
                    var d = parseFloat(data).toFixed(2);
                    return d;
                }
            },
            { data: 'costCenter' },
            { data: 'ledgerName', visible: false },
            { data: 'transactionNumber', visible: false },
            { data: 'drawnDate', visible: false },
            { data: 'cardNumber', visible: false },
            { data: 'price', visible: false },
            { data: 'invoiceDate', visible: false },
            { data: 'estimatedPrice', visible: false },
            { data: 'companyName', visible: false },
            { data: 'driverDescription', visible: false },
            { data: 'isBunkered', visible: false }],
            initComplete: function () {
                var api = this.api();
                api.columns().every(function () {
                    var that = this;
                    //console.log(that);
                    $('input', this.footer()).on('keyup change', function () {
                        if (that.search() !== this.value) {
                            that.search(this.value).draw();
                        }
                    });
                });
            }

        }
        // this.loadCards();
    }

    downloadCardTransaction(type: string) {
        this.loaderService.display(true);
        //this.getCardTransDocument(this.referenceNumber, type);
        this.getCardTransDocumentNew(this.referenceNumber, type);
    }

    getCardTransDocument(refNumber: string, type: string) {

        let callURL = ApiEndPoints.BaseURL + ApiEndPoints.DownloadCardTransEndPoint;
        callURL = callURL.replace("{id}", refNumber).replace("{type}", type);
        //let headers: Headers = new Headers({
        //  'Content-Type': 'application/x-www-form-urlencoded;'
        //});
        return this.httpcall
            .get(callURL, {
                responseType: ResponseContentType.Blob
            })
            .map(res => {
                const contentDisposition = res.headers.get('content-disposition') || '';
                const matches = /filename=([^;]+)/ig.exec(contentDisposition);
                const fileName = (matches[1] || 'untitled').trim();
                return {
                    filename: fileName,
                    data: res.blob()
                };
            })
            .subscribe(res => {
                if (navigator.appVersion.toString().indexOf('.NET') > 0 || navigator.msSaveBlob) {
                    window.navigator.msSaveBlob(res.data, res.filename);
                    this.loaderService.display(false);
                }
                else {
                    var url = window.URL.createObjectURL(res.data);
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.setAttribute('style', 'display: none');
                    a.href = url;
                    a.download = res.filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    a.remove(); // remove the element
                    this.loaderService.display(false);
                }
            }, error => {
                this.loaderService.display(false);
                //alert('download error:' + JSON.stringify(error));
                this.cardTransactionFrm.ngSubmit.emit();
                //console.log('download error:', JSON.stringify(error));
            }, () => {
                //console.log('Completed file download.')
            });
    }

    getCardTransDocumentNew(refNumber: string, type: string) {
        var sort = "";
        if (this.cardTransactionTypeValue == undefined || this.cardTransactionTypeValue == 1) {
            sort = "drawn";
        }
        else {
            sort = "invoiced";
        }

        this.cardTransactionService.prePareCardTransDocument(refNumber, type, sort, "card")
            .subscribe(
                (acceptedResponse: AcceptedResponse) => {
                    if (acceptedResponse.error == "NoReferenceFound") {
                        this.cardTransactionFrm.ngSubmit.emit();
                    }
                    else {
                        this.checkPrepareCardTransStatus(acceptedResponse, type);
                    }
                },
                (error: any) => {
                    this.loaderService.display(false);
                    this.cardTransactionService.showError("Card transaction prepare problem", <any>error);
                }
            );
    }

    checkPrepareCardTransStatus(acceptedResponse: AcceptedResponse, type: string) {
        if (acceptedResponse.statuscode == "202") {
            var athis = this;
            setTimeout(function () {
                athis.cardTransactionService.checkDrawingStatus(acceptedResponse.location)
                    .subscribe(
                        (response: AcceptedResponse) => {
                            athis.checkPrepareCardTransStatus(response, type);
                        },
                        (error: any) => {
                            athis.loaderService.display(false);
                            athis.cardTransactionService.showError("Card transaction prepare problem", <any>error);
                        }
                    );
            }, acceptedResponse.retryafter);
        }
        else if (acceptedResponse.statuscode == "200") {
            if (acceptedResponse.error != null) {
                this.loaderService.display(false);
                this.cardTransactionService.showError("Card transaction prepare problem", <any>acceptedResponse.error);
            }
            else {
                if (acceptedResponse.referenceNumber != null) {
                    this.downloadCardTransDocument(acceptedResponse.referenceNumber, type);
                }
                else {
                    this.loaderService.display(false);
                    this.cardTransactionService.showError("Card transaction prepare problem", <any>acceptedResponse.error);
                }
            }
        }
        else if (acceptedResponse.statuscode == "400") {
            this.loaderService.display(false);
            this.cardTransactionService.showError("Card transaction prepare problem", <any>acceptedResponse.error);
        }
    }

    downloadCardTransDocument(refNumber: string, type: string) {
        let callURL = ApiEndPoints.BaseURL + ApiEndPoints.DownloadNewCardTransEndPoint;
        callURL = callURL.replace("{id}", refNumber).replace("{type}", type);
        //let headers: Headers = new Headers({
        //  'Content-Type': 'application/x-www-form-urlencoded;'
        //});
        return this.httpcall
            .get(callURL, {
                responseType: ResponseContentType.Blob
            })
            .map(res => {
                const contentDisposition = res.headers.get('content-disposition') || '';
                const matches = /filename=([^;]+)/ig.exec(contentDisposition);
                const fileName = (matches[1] || 'untitled').trim();
                return {
                    filename: fileName,
                    data: res.blob()
                };
            })
            .subscribe(res => {
                if (navigator.appVersion.toString().indexOf('.NET') > 0 || navigator.msSaveBlob) {
                    window.navigator.msSaveBlob(res.data, res.filename);
                    this.loaderService.display(false);
                }
                else {
                    var url = window.URL.createObjectURL(res.data);
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.setAttribute('style', 'display: none');
                    a.href = url;
                    a.download = res.filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    a.remove(); // remove the element
                    this.loaderService.display(false);
                }
            }, error => {
                this.loaderService.display(false);
                //alert('download error:' + JSON.stringify(error));
                this.cardTransactionFrm.ngSubmit.emit();
                //console.log('download error:', JSON.stringify(error));
            }, () => {
                //console.log('Completed file download.')
            });
    }

    dtOptionCardsTable() {
        this.dtOptionsCardsTable = {
            dom: '<"top"f<"clear">>rt<"bottom"ip<"clear">>',
            responsive: true,
            info: false,
            order: [],
            columnDefs: [{ "type": "non-empty-string", targets: [1, 2, 3, 4] }]
        }
    }

    loadCards() {
        this.loaderService.display(true);
        //setTimeout(function () { alert("Hello"); }, 3000);
        var model: CardTranLiveCardModel = new CardTranLiveCardModel();
        model.AccountId = [];
        model.Token = this.authService.getToken().access_token;
        //model.EndPointURL = ApiEndPoints.CardsEndPoint;

        this.accessAccounts.forEach(item => {
            //model.AccountId.push(item.id);
            model.AccountId.push(item.name);
        });
        this.cardTransactionService.getCardsList(model)
            .subscribe(
                (cards: ICards[]) => {
                    if (cards == null) {
                        cards = [];
                    }
                    this.cardListData = cards;
                    //console.log(this.cardList);
                    this.LoadCardList("All");
                    this.loadDrawingPointList();
                    // this.dtTrigger.next();
                },
                (error: any) => {
                    this.loaderService.display(false);
                    this.cardTransactionService.showError("Cards retrieval problem", <any>error);
                }
            );
    }

    loadDrawingPointList() {
        var model: CardTranDrawingPointModel = new CardTranDrawingPointModel();
        model.AccountId = [];
        model.Token = this.authService.getToken().access_token;
       // model.EndPointURL = ApiEndPoints.DrawingPointEndPoint;

        this.accessAccounts.forEach(item => {
            model.AccountId.push(item.id);
        });
        this.cardTransactionService.getDrawingPointList(model)
            .subscribe(
                (drawingAccounts: IDrawingAccounts[]) => {
                    this.drawingAccountList = drawingAccounts;
                    this.loaderService.display(false);
                    setTimeout(function () { $("#ddlDA").val("All"); }, 50);
                },
                (error: any) => {
                    this.loaderService.display(false);
                    this.cardTransactionService.showError("Drawing Accounts retrieval problem", <any>error);
                }
            );
    }

    onSubmit(cardTransaction: any) {
        //debugger;
        $('.showtable').removeClass('open');
        this.drawingList = null;
        this.drawingListDummy = null;
        this.showDrawings = false;
        this.loaderService.display(true);
        let queryString = "";
        this.dtOption_result();
        let isValid = true;
        let message = "";
        if (cardTransaction.startDate == undefined && cardTransaction.endDate == undefined) {
            //debugger;
            isValid = this.CalculateDiff(cardTransaction.startDate, cardTransaction.endDate)
            if (!isValid) {
                message = "Please select a date range."
                alert(message);
            }
            // message = "Please select a date range."

            this.loaderService.display(false);
            this.drawingList = [];
        }
        else {
            if (cardTransaction.startDate != undefined && cardTransaction.endDate != undefined) {
                isValid = this.CalculateDiff(cardTransaction.startDate, cardTransaction.endDate)
                //debugger;
                if (!isValid) {
                    message = "Please select a date range."
                    alert(message);
                    this.loaderService.display(false);
                    this.drawingList = [];

                }
                else {
                    //var values = new Array();
                    //$.each($("input[name='case[]']:checked"), function () {            
                    //    var data = $(this).parents('tr:eq(0)');            
                    //    var value = $(data).find('td:eq(1)').text();            
                    //    values.push(value);
                    //});

                    var values = new Array();
                    let selectedCards = this.cardList.filter(x => x.selected === true);
                    selectedCards.forEach(eachObj => {
                        values.push(eachObj.cardNumber);
                    });

                    if (values != null && values.length > 0) {
                        queryString = "cards=";
                        let cards = "";
                        for (var i = 0; i < values.length; i++) {
                            cards = values[i] + "," + cards;
                        }

                        cards = cards.substring(0, cards.length - 1);
                        queryString = queryString + cards;
                    }

                    // else {
                    if (cardTransaction.drawingAccount == undefined || cardTransaction.drawingAccount == "All") {
                        //debugger;
                        queryString = queryString + "&drawingPoints=";
                        let drawingPoints = "";
                        if (this.drawingAccountList != null) {
                            for (var i = 0; i < this.drawingAccountList.length; i++) {
                                drawingPoints = this.drawingAccountList[i].number + "," + drawingPoints;
                            }
                            drawingPoints = drawingPoints.substring(0, drawingPoints.length - 1);
                            queryString = queryString + drawingPoints;
                        }
                        
                      
                    }
                    else {
                        queryString = queryString + "&drawingPoints=" + this.selectedDrawingPoint.number;
                    }
                    //}

                    if (cardTransaction.Type == undefined || cardTransaction.Type == 1) {
                        this.cardTransactionTypeValue = cardTransaction.Type;
                        if (cardTransaction.startDate != undefined) {
                            cardTransaction.drawnStartDate = this.convert(cardTransaction.startDate);
                            queryString = queryString + "&drawnStartDate=" + this.convert(cardTransaction.drawnStartDate) + " 00:00";

                        }
                        if (cardTransaction.endDate != undefined) {
                            cardTransaction.drawnEndDate = this.convert(cardTransaction.endDate);
                            queryString = queryString + "&drawnEndDate=" + this.convert(cardTransaction.drawnEndDate) + " 23:59:00";

                        }
                        queryString = queryString + "&cardTransactionType=" + "drawn";
                    }

                    else if (cardTransaction.Type == 2) {
                        this.cardTransactionTypeValue = cardTransaction.Type;
                        if (cardTransaction.startDate != undefined) {
                            cardTransaction.invoicedStartDate = this.convert(cardTransaction.startDate);
                            queryString = queryString + "&invoicedStartDate=" + this.convert(cardTransaction.invoicedStartDate);

                        }
                        if (cardTransaction.endDate != undefined) {
                            cardTransaction.invoicedEndDate = this.convert(cardTransaction.endDate);
                            queryString = queryString + "&invoicedEndDate=" + cardTransaction.invoicedEndDate;
                        }
                        queryString = queryString + "&cardTransactionType=" + "invoiced";
                    }
                    queryString = queryString + "&excludeDrawingsWithoutCo2Count=" + false;
                    var model: CardTranDrawingModel = new CardTranDrawingModel();
                    model.AccountId = [];
                    model.Token = this.authService.getToken().access_token;
                    //model.EndPointURL = ApiEndPoints.DrawingEndPoint + queryString;
                    model.QueryValue = queryString;
                    model.UserName = this.loggedUser.name;
                    let userData = JSON.parse(sessionStorage.getItem(("userData_EServicesExternalLocalhost")));
                    if (userData == undefined) {
                        userData = JSON.parse(sessionStorage.getItem(("userData_EServicesExternal")));
                    }
                    model.UserId = userData.sub;
                    this.accessAccounts.forEach(item => {
                        model.AccountId.push(item.id);
                    });
                    model.referenceNumber = this.referenceNumber;

                    //this.cardTransactionService.getDrawingsNew(model)
                    //  .subscribe(
                    //  (drawingAccounts: IDrawings[]) => {
                    //    this.drawingList = drawingAccounts;
                    //    this.loaderService.display(false);
                    //  },
                    //  (error: any) => {
                    //    this.loaderService.display(false);
                    //    this.cardTransactionService.showError("Drawing Accounts retrieval problem", <any>error);
                    //  }
                    //  );


                    if (cardTransaction.startDate != undefined && cardTransaction.endDate != undefined) {
                        isValid = this.CalculateDiff(cardTransaction.startDate, cardTransaction.endDate)
                        if (!isValid) {
                            message = "Please select a date range."
                        }
                    }


                    if (isValid) {
                        this.cardTransactionService.getDrawingsNew(model)
                            .subscribe(
                                (acceptedResponse: AcceptedResponse) => {
                                    this.checkCardTransStatus(acceptedResponse);
                                    //if (drawingsDataTablesResponse.data.length > 0){
                                    //  this.drawingListDummy = drawingsDataTablesResponse.data;
                                    //  this.referenceNumber = drawingsDataTablesResponse.referenceNumber;
                                    //}
                                    //this.loaderService.display(false);
                                },
                                (error: any) => {
                                    this.loaderService.display(false);
                                    this.cardTransactionService.showError("Drawing Accounts retrieval problem", <any>error);
                                }
                            );
                    }
                    else {
                        this.loaderService.display(false);
                        this.drawingList = [];
                        alert(message)
                    }
                }
            }
        }

    }

    checkCardTransStatus(acceptedResponse: AcceptedResponse) {
        if (acceptedResponse.statuscode == "202") {
            var athis = this;
            setTimeout(function () {
                athis.cardTransactionService.checkDrawingStatus(acceptedResponse.location)
                    .subscribe(
                        (response: AcceptedResponse) => {
                            athis.checkCardTransStatus(response);
                            //console.log(response);
                        },
                        (error: any) => {
                            athis.loaderService.display(false);
                            athis.cardTransactionService.showError("Drawing Accounts retrieval problem", <any>error);
                        }
                    );
            }, acceptedResponse.retryafter);
        }
        else if (acceptedResponse.statuscode == "200") {
            if (acceptedResponse.error != null) {
                this.loaderService.display(false);
                this.cardTransactionService.showError("Drawing Accounts retrieval problem", <any>acceptedResponse.error);
            }
            else {
                if (acceptedResponse.referenceNumber != null) {
                    this.showDrawings = true;
                    this.referenceNumber = acceptedResponse.referenceNumber;
                }
                else {
                    this.loaderService.display(false);
                    this.cardTransactionService.showError("Drawing Accounts retrieval problem", <any>acceptedResponse.error);
                }
            }
        }
        else if (acceptedResponse.statuscode == "400") {
            this.loaderService.display(false);
            this.cardTransactionService.showError("Drawing Accounts retrieval problem", <any>acceptedResponse.error);
        }
    }

    selectAllCardsChange(e) {
        if (e.target.checked) {
            this.cardList.forEach(eachObj => {
                eachObj.selected = true;
            });
        }
        else {
            this.cardList.forEach(eachObj => {
                eachObj.selected = false;
            });
        }
    }

    convert(str) {
        var date = new Date(str),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
        return [date.getFullYear(), mnth, day].join("-");
    }


    //Clear Selection Of Table
    ClearSelection() {
        //$('#selectcardsdatatable thead th input[type=checkbox]').removeAttr('checked');
        //var set = $("#selectcardsdatatable tbody tr input[type=checkbox]");
        //var checked = $(this).is(":checked");
        //$(set).each(function () {
        //    $(this).prop("checked", false);
        //    $(this).parents('tr').removeClass("active");
        //});
        let selectedCards = this.cardList.filter(x => x.selected === true);
        selectedCards.forEach(eachObj => {
            eachObj.selected = false;
        });
    }

    //clear date
    ClearDate(cardTransaction) {
        cardTransaction.startDate = null;
        cardTransaction.endDate = null;
    }
    ngOnDestroy() {
        // prevent memory leak when component destroyed
        let userData = JSON.parse(sessionStorage.getItem(("userData_EServicesExternalLocalhost")));
        if (userData == undefined) {
            userData = JSON.parse(sessionStorage.getItem(("userData_EServicesExternal")));
        }
        let UserId = userData.sub;
        debugger
        this.cardTransactionService.UnScubscribeCardTransactionMemory(UserId)
            .subscribe(
                (data: null) => {

                },
                (error: any) => {

                }
            );
    }

    LoadCardList(drawingPointId) {

        let cardData;
        var table = $('#selectcardsdatatable').DataTable();
        table.destroy();
        this.cardListData.forEach(x => {
            x.selected = false;
        });
        this.selectedDrawingPoint = {};
        if (drawingPointId === "All") {
            cardData = this.cardListData;
            this.selectedDrawingPoint.number = "All";
        }
        else {
            cardData = this.cardListData.filter(x => x.drawingPointId == drawingPointId);
            this.selectedDrawingPoint = this.drawingAccountList.filter(x => x.id === drawingPointId)[0];
        }

        // this.cardTransaction.drawingAccount = this.drawingAccountList.filter(x => x.id === drawingPointId)[0].number;
        this.cardList = cardData;

        this.dtTrigger.next();
    }


    CalculateDiff(fromaDate: any, toDate: any): boolean {
        //debugger;
        var diff = Math.floor((Date.parse(toDate) - Date.parse(fromaDate)) / 86400000);

        if (Number.isNaN(diff) || diff < 0) {
            return false;
        }
        else {
            return true;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/cardtransaction/accountcardtransaction.component.ts